export default __webpack_public_path__ + "static/media/generic-form-draft-thumbnail-1x.bd7817c4.png";